import React, {useEffect, useState} from 'react';
import {DndContext, closestCenter} from '@dnd-kit/core';
import {
    SortableContext,
    horizontalListSortingStrategy,
} from '@dnd-kit/sortable';
import {Box, IconButton} from '@mui/material';
import DraggableItem from './DraggableItemComponent';
import {MamClipElement} from '../../../types/clipTypes';
import {useTheme} from "../../../contexts/theme";
import CropSquareIcon from "@mui/icons-material/CropSquare";

interface HorizontalDraggableListProps {
    items: any[];
    setItems: (items: any[]) => void;
    deleteClipDraggable?: (id: string) => void;
    flexWrap?: 'wrap' | 'nowrap';
    overflowY?: 'auto' | 'none';
    overflowX?: 'auto' | 'none';
    gap? : number;
    viewTag?: boolean;
    handleChangeClipSelection?: (id: string) => void;
    mode?: "template" | "asset";
}

const DraggableList = ({items, setItems, deleteClipDraggable, flexWrap = 'nowrap', overflowX = 'auto', overflowY = 'none', gap, viewTag = true, handleChangeClipSelection, mode}: HorizontalDraggableListProps) => {
    const theme = useTheme();



    const handleDragEnd = (event: any) => {

        const {active, over} = event;


        if (!over) return;

        if (active.id !== over.id) {


            // Trova gli indici dell'elemento attivo e dell'elemento target
            const oldIndex = items.findIndex((item) => item.id === active.id);
            const newIndex = items.findIndex((item) => item.id === over.id);


            if (oldIndex === -1 || newIndex === -1) return;

            // Crea una nuova copia degli elementi
            const updatedItems = [...items];
            const [movedItem] = updatedItems.splice(oldIndex, 1);
            updatedItems.splice(newIndex, 0, movedItem);
            setItems(updatedItems);
        }
    };


    const handleDragStart = (event: React.MouseEvent | React.TouchEvent) => {
        event.preventDefault(); // Prevent scrolling


    };

    let rowGap = gap?.toString()+"em"
    return (
        <Box display={'flex'} flexDirection={'column'}>
            <Box>
                <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                    <SortableContext items={items.map((item: any) => item.id)} strategy={horizontalListSortingStrategy}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: {flexWrap},
                                overflowX: {overflowX},
                                overflowY: {overflowY},
                                bgcolor: 'background.paper',
                                width: '100%',
                                gap: {gap},
                                rowGap: {rowGap},
                                height: '100%',
                                backgroundColor: theme.palette.blue,
                            }}
                            onTouchMove={handleDragStart}
                            onPointerMove={handleDragStart}
                        >
                            {items.map((item: any) => {

                                return (

                                    <DraggableItem mode={mode} viewTag={viewTag} key={item.id} id={item.id} content={item} checkedTemplate={item.selected} handleCheckTemplate={handleChangeClipSelection}
                                                   deleteClipDraggable={deleteClipDraggable}/>

                                );
                            })}
                        </Box>
                    </SortableContext>
                </DndContext>
            </Box>
        </Box>
    );
};

export default DraggableList;
